/**
 * hooks/useConversor.ts
 * Estado simple para el modal del conversor de coordenadas.
 *
 * Sin contexto global — se instancia en App.tsx y se pasa
 * como props a HeaderSection y FooterSection.
 *
 * @version 1.0.0
 */
import { useState, useCallback } from 'react';

export interface UseConversorReturn {
  isOpen: boolean;
  open:   () => void;
  close:  () => void;
}

export function useConversor(): UseConversorReturn {
  const [isOpen, setIsOpen] = useState(false);

  const open  = useCallback(() => setIsOpen(true),  []);
  const close = useCallback(() => setIsOpen(false), []);

  return { isOpen, open, close };
}
